<template>
  <div>
    <div class="title">
      <div class="wp-block-group section-title">
        <div class="wishlist__title">
          <div class="wishlist__title__left">
            <h2>{{ wishlistTitle() }}</h2>

            <template v-if="hasProducts()">
              <button class="button button--orange button__share" type="button" @click="copyWishlist">
                <i data-feather="share-2"></i>
                {{ this.translations.share }}
              </button>

              <button class="button__download js-generate-excel" type="button" @click="generateExcel">
                <img :src="excelUrl" alt="Excel icon">
                {{ this.translations.download }}
                <i data-feather="download"></i>
              </button>
            </template>
          </div>

          <div class="wishlist__title__right" v-if="hasProducts() || isLoggedIn">
            <button class="button__download" type="button" v-if="hasProducts()">
              <img :src="excelUrl" alt="Excel icon">
              {{ this.translations.download }}
              <i data-feather="download"></i>
            </button>

            <a :href="this.viewAllUrl" v-if="isLoggedIn">
              <i data-feather="arrow-right"></i>
              {{ getViewAllTitle() }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <ProductsPagination v-if="hasProducts() || $store.state.view.isLoading || $store.state.view.isLoadingProducts">
      <ProductsLayout />
    </ProductsPagination>
    <div v-else="">
      {{ this.translations.empty }}
    </div>
  </div>
</template>

<script>
import ProductsPagination from '@/layouts/wishlist/pagination/Pagination.vue';
import ProductsLayout from '@/layouts/archive/product-grid/ProductsLayout.vue';
import qs from "qs";

export default {
  components: {
    ProductsPagination,
    ProductsLayout
  },
  data() {
    return {
      isLoggedIn: Boolean(ws_vue_store.logged_in),
      viewAllUrl: ws_vue_store.site_url + '/my-account/my-wishlists/',
      translations: {
        defaultTitle: ws_vue_store.translations.wishlist_title,
        copyLink: ws_vue_store.translations.wishlist_copy_link,
        share: ws_vue_store.translations.wishlist_share,
        download: ws_vue_store.translations.file_download,
        viewAll: ws_vue_store.translations.wishlist_view_all,
        empty: ws_vue_store.translations.wishlist_empty
      },
      excelUrl: ws_vue_store.site_url + '/wp-content/themes/hekamerk/assets/src/img/svg/XSL.svg',
      pdfURL: ws_vue_store.site_url + '/wp-content/themes/hekamerk/assets/src/img/svg/PDF.svg',
    };
  },
  methods: {
    generateExcel() {
      document.dispatchEvent(new Event('wsExcelGenerate'));
    },
    copyWishlist() {
      let link = ws_vue_store.site_url + '/'
        + ws_vue_store.sub_urls.shop + '/'
        + ws_vue_store.sub_urls.wishlist + '/'
        + this.$router.currentRoute.params.wishlist_uid;

      navigator.clipboard.writeText(link);

      this.$store.dispatch("displayWoocommerceNotice", {
        message: this.translations.copyLink
      });
    },
    wishlistTitle() {
      return ws_vue_store.view_wishlist ? ws_vue_store.view_wishlist.name : this.translations.defaultTitle;
    },
    getViewAllTitle() {
      if (ws_vue_store.view_wishlist && ws_vue_store.view_wishlist.total) {
        return this.translations.viewAll + ` (${ws_vue_store.view_wishlist.total})`;
      }
      return this.translations.viewAll;
    },
    hasProducts() {
      return this.$store.state.products && this.$store.state.products.length > 0;
    }
  },
  computed: {}
};
</script>
